import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-updown-arrow-toggle-button',
  templateUrl: './updown-arrow-toggle-button.component.html',
  styleUrls: ['./updown-arrow-toggle-button.component.scss']
})
export class UpdownArrowToggleButtonComponent {
  @Input() seeAllText = 'See All';
  @Input() seeLessText = 'See Less';
  @Input() iconPath = '/assets/SVGIcons/downarrow.svg';
  @Input() isExpanded = false;

  @Output() expandedChange = new EventEmitter<boolean>();

  constructor(){}

  toggle() {
    this.expandedChange.emit(!this.isExpanded);
  }
}
